<template>
  <div>
    <v-row v-if="!isMobile" style="height:600px">
      <v-col v-for="(product, key) in products" lg="3" md="4" sm="6" xs="6" >
        <transition-group mode="in-out" name="fade-transition">
          <product-card v-bind:product="product" :poster="false" style="padding:46px;" :key="key"></product-card>
        </transition-group>
      </v-col>
    </v-row>

    <v-row v-if="isMobile">
      <v-col v-if="ready" v-for="(product, key) in products" cols="6" height="230px"  :style="(key/2) === 0 ? 'padding:16px; padding-right: 6px; padding-left:12px;' : 'padding:16px; padding-left:6px; padding-right: 12px;'">
        <product-card v-bind:product="product" :poster="false" :key="key"></product-card>
      </v-col>

      <!-- <v-col v-for="key in 1" cols="6"  :style="(key/2) === 0 ? 'padding:16px; padding-right: 6px; padding-left:12px;' : 'padding:16px; padding-left:6px; padding-right: 12px;'">
        <v-skeleton-loader
          ref="skeleton"
          :loading="true"
          type="image"
          :tile="true"
          class="pl-3"
          height="230px"
        ></v-skeleton-loader>
        <br>
        <v-skeleton-loader
          ref="skeleton"
          :loading="true"
          type="text"
          :tile="true"
          class="pl-3"
        ></v-skeleton-loader>
        <v-skeleton-loader
          ref="skeleton"
          :loading="true"
          type="text"
          :tile="true"
          class="pl-3"
        ></v-skeleton-loader>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue';

export default {
  name: 'ProductList',
  components: {
    ProductCard
  },
  props: ['products'],
  data: () => ({
    isMobile: false,
    ready: false,
  }),
  mounted () {
    this.setIsMobile();
    let component = this;
    setTimeout(function () {
      component.ready = true;
    }, 500);
  },
  methods: {
    setIsMobile() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        this.isMobile = true;
      }
    }
  }
};
</script>

<style lang="scss">
/* .v-skeleton-loader__image {
  height: 230px!important;
  border-radius: 0;
} */

  $skeleton-loader-image-height: 300px;
</style>
